import { Input } from 'antd';
import { useState } from 'react';
import { formatExamples, parseExamples } from './aiChatSkills';

interface Props {
  value?: string[];
  onChange: (examples: string[]) => void;
  placeholder?: string;
  ariaLabel?: string;
}

/**
 * 示例提问输入框（每行一条）。
 *
 * <p>编辑期间必须显示用户敲进去的原始文本：直接 value={formatExamples(value)} 的话，
 * 按下 Enter 产生的尾随空行会被 parseExamples 立刻丢掉再回填，换行看上去被吃掉，
 * 用户根本没法换到下一行。因此编辑态用本地 draft，失焦后再回到规范化文本；
 * 向上给出的始终是规范化后的数组。
 */
export default function AiChatSkillExamplesInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: Props) {
  const [draft, setDraft] = useState<string | null>(null);

  return (
    <Input.TextArea
      rows={2}
      placeholder={placeholder}
      aria-label={ariaLabel}
      value={draft ?? formatExamples(value)}
      onChange={(e) => {
        setDraft(e.target.value);
        onChange(parseExamples(e.target.value));
      }}
      onBlur={() => setDraft(null)}
    />
  );
}
